import Layout from "@/page/index/";

export default [
  {
    path: "/wel",
    component: Layout,
    redirect: "/wel/index",
    children: [
      {
        path: "index",
        name: "首页",
        meta: {
          i18n: "dashboard",
          keepAlive: true,
        },
        component: () =>
          import(/* webpackChunkName: "views" */ "@/views/wel/index"),
      },
    ],
  },
  {
    path: "/info",
    component: Layout,
    redirect: "/info/index",
    children: [
      {
        path: "/info/index",
        name: "个人信息",
        meta: {
          i18n: "info",
        },
        component: () =>
          import(/* webpackChunkName: "views" */ "@/views/system/userinfo"),
      },
    ],
  },
  {
    path: "/system/warning-mechanism",
    component: Layout,
    redirect: "/system/warning-mechanism/index",
    children: [
      {
        path: "index",
        name: "预警机制",
        meta: {
          keepAlive: true,
        },
        component: () =>
          import(
            /* webpackChunkName: "views" */ "@/views/system/warning-mechanism/index"
          ),
      },
    ],
  },
  // 摄像头管理：与菜单 path=/system/device-camera 对齐；动态菜单未下发时避免 404
  {
    path: "/system/device-camera",
    component: Layout,
    redirect: "/system/device-camera/index",
    children: [
      {
        path: "index",
        name: "摄像头管理",
        meta: {
          keepAlive: true,
        },
        component: () =>
          import(
            /* webpackChunkName: "views" */ "@/views/system/device-camera/index"
          ),
      },
    ],
  },
  // 设备点检异常：与菜单 path=/system/device-inspection-error/index 对齐；动态菜单缓存未更新时避免刷新空白
  {
    path: "/system/device-inspection-error",
    component: Layout,
    redirect: "/system/device-inspection-error/index",
    children: [
      {
        path: "index",
        name: "设备点检异常",
        meta: {
          keepAlive: true,
        },
        component: () =>
          import(
            /* webpackChunkName: "views" */ "@/views/system/device-inspection-error/index"
          ),
      },
    ],
  },
  // 通知公告：与 Blade 菜单 path=/desk/notice 对齐；动态菜单未下发时避免 404
  {
    path: "/desk/notice",
    component: Layout,
    children: [
      {
        path: "",
        name: "通知公告",
        meta: {
          keepAlive: true,
        },
        component: () =>
          import(/* webpackChunkName: "views" */ "@/views/desk/notice"),
      },
    ],
  },
  // 入厂须知：与菜单 path=/basic-info/driver-entry-standard/index 对齐
  {
    path: "/basic-info/driver-entry-standard",
    component: Layout,
    redirect: "/basic-info/driver-entry-standard/index",
    children: [
      {
        path: "index",
        name: "入厂须知",
        meta: {
          keepAlive: true,
        },
        component: () =>
          import(
            /* webpackChunkName: "views" */ "@/views/basic-info/driver-entry-standard/index"
          ),
      },
      {
        path: "read-record",
        name: "阅读记录",
        meta: {
          keepAlive: true,
        },
        component: () =>
          import(
            /* webpackChunkName: "views" */ "@/views/basic-info/driver-entry-standard/read-record"
          ),
      },
    ],
  },
  {
    path: "/railway-management/outInStockRecord/info",
    component: Layout,
    redirect: "/railway-management/outInStockRecord/info",
    children: [
      {
        path: "/railway-management/outInStockRecord/info",
        name: "入库详情",
        meta: {
          i18n: "outInStockRecordInfo",
        },
        component: () =>
          import("@/views/railway-management/outInStockRecord/components/info"),
      },
    ],
  },
  {
    path: "/dispatched-personnel-track/check-inspection-plan-list/create",
    component: Layout,
    redirect: "/dispatched-personnel-track/check-inspection-plan-list/create",
    children: [
      {
        path: "/dispatched-personnel-track/check-inspection-plan-list/create",
        name: "新建检查计划",
        meta: {
          i18n: "createCheckPlan",
          keepAlive: false,
        },
        component: () =>
          import(
            /* webpackChunkName: "views" */ "@/views/dispatched-personnel-track/check-inspection-plan-list/create"
          ),
      },
    ],
  },
  {
    path: "/dispatched-personnel-track/check-inspection-plan-list/detail/:id",
    component: Layout,
    redirect:
      "/dispatched-personnel-track/check-inspection-plan-list/detail/:id",
    children: [
      {
        path: "/dispatched-personnel-track/check-inspection-plan-list/detail/:id",
        name: "检查计划详情",
        meta: {
          i18n: "checkPlanDetail",
          keepAlive: false,
        },
        component: () =>
          import(
            /* webpackChunkName: "views" */ "@/views/dispatched-personnel-track/check-inspection-plan-list/detail"
          ),
      },
    ],
  },
  {
    path: "/dispatched-personnel-track/InspectionTaskManage/detail/:id",
    component: Layout,
    redirect: "/dispatched-personnel-track/InspectionTaskManage/detail/:id",
    children: [
      {
        path: "/dispatched-personnel-track/InspectionTaskManage/detail/:id",
        name: "巡检任务详情",
        meta: {
          i18n: "inspectionTaskDetail",
          keepAlive: false,
        },
        component: () =>
          import(
            /* webpackChunkName: "views" */ "@/views/dispatched-personnel-track/InspectionTaskManage/detail"
          ),
      },
    ],
  },
  {
    path: "/dispatched-personnel-track/fault-report-material",
    component: Layout,
    redirect: "/dispatched-personnel-track/fault-report-material",
    children: [
      {
        path: "/dispatched-personnel-track/fault-report-material",
        name: "故障汇报资料管理",
        meta: { keepAlive: true },
        component: () =>
          import(
            /* webpackChunkName: "views" */ "@/views/dispatched-personnel-track/fault-report-material/index"
          ),
      },
    ],
  },
  {
    path: "/dispatched-personnel-track/personnel-status-stats",
    component: Layout,
    redirect: "/dispatched-personnel-track/personnel-status-stats",
    children: [
      {
        path: "/dispatched-personnel-track/personnel-status-stats",
        name: "人员状态统计",
        meta: { keepAlive: true },
        component: () =>
          import(
            /* webpackChunkName: "views" */ "@/views/dispatched-personnel-track/personnel-status-stats/index"
          ),
      },
    ],
  },
  {
    path: "/dispatched-personnel-track/InspectionRoleManage",
    component: Layout,
    redirect: "/dispatched-personnel-track/InspectionRoleManage",
    children: [
      {
        path: "/dispatched-personnel-track/InspectionRoleManage",
        name: "巡检角色管理",
        meta: { keepAlive: true },
        component: () =>
          import(
            /* webpackChunkName: "views" */ "@/views/dispatched-personnel-track/InspectionRoleManage/index"
          ),
      },
    ],
  },
  {
    path: "/dispatched-personnel-track/ElectronicFenceManage",
    component: Layout,
    redirect: "/dispatched-personnel-track/ElectronicFenceManage",
    children: [
      {
        path: "/dispatched-personnel-track/ElectronicFenceManage",
        name: "电子围栏管理",
        meta: { keepAlive: true },
        component: () =>
          import(
            /* webpackChunkName: "views" */ "@/views/dispatched-personnel-track/ElectronicFenceManage/index"
          ),
      },
    ],
  },
  {
    path: "/dispatched-personnel-track/ElectronicFenceAlarm",
    component: Layout,
    redirect: "/dispatched-personnel-track/ElectronicFenceAlarm",
    children: [
      {
        path: "/dispatched-personnel-track/ElectronicFenceAlarm",
        name: "电子围栏报警",
        meta: { keepAlive: true },
        component: () =>
          import(
            /* webpackChunkName: "views" */ "@/views/dispatched-personnel-track/ElectronicFenceAlarm/index"
          ),
      },
    ],
  },
  {
    path: "/dispatched-personnel-track/RtkSosAlarm",
    component: Layout,
    redirect: "/dispatched-personnel-track/RtkSosAlarm",
    children: [
      {
        path: "/dispatched-personnel-track/RtkSosAlarm",
        name: "RTK SOS告警",
        meta: { keepAlive: true },
        component: () =>
          import(
            /* webpackChunkName: "views" */ "@/views/dispatched-personnel-track/RtkSosAlarm/index"
          ),
      },
    ],
  },
  {
    path: "/railway-management/arrival-analysis",
    component: Layout,
    redirect: "/railway-management/arrival-analysis",
    children: [
      {
        path: "/railway-management/arrival-analysis",
        name: "铁路到站量趋势分析",
        meta: { i18n: "arrivalAnalysis", keepAlive: true },
        component: () =>
          import("@/views/railway-management/arrival-analysis/index"),
      },
    ],
  },
  {
    path: "/railway-management/multi-transport-data",
    component: Layout,
    redirect: "/railway-management/multi-transport-data",
    children: [
      {
        path: "/railway-management/multi-transport-data",
        name: "多维数据查询与智能分析",
        meta: { i18n: "multiTransportData", keepAlive: true },
        component: () =>
          import("@/views/railway-management/multi-transport-data/index"),
      },
    ],
  },
  {
    path: "/railway-management/plan-completion-analysis",
    component: Layout,
    redirect: "/railway-management/plan-completion-analysis",
    children: [
      {
        path: "/railway-management/plan-completion-analysis",
        name: "铁路计划完成率分析",
        meta: { i18n: "planCompletionAnalysis", keepAlive: true },
        component: () =>
          import("@/views/railway-management/plan-completion-analysis/index"),
      },
    ],
  },
  {
    path: "/railway-management/railway-unload-efficiency-daily",
    component: Layout,
    redirect: "/railway-management/railway-unload-efficiency-daily",
    children: [
      {
        path: "/railway-management/railway-unload-efficiency-daily",
        name: "铁路卸车作业效率日报",
        meta: { i18n: "railwayUnloadEfficiencyDaily", keepAlive: true },
        component: () =>
          import("@/views/railway-management/railway-unload-efficiency-daily/index"),
      },
      {
        path: "/railway-management/railway-unload-line-efficiency",
        name: "卸车线作业效率分析",
        meta: { i18n: "railwayUnloadLineEfficiency", keepAlive: true },
        component: () =>
          import("@/views/railway-management/railway-unload-line-efficiency/index"),
      },
    ],
  },
  {
    path: "/roadoutbound/auto-load-efficiency",
    component: Layout,
    redirect: "/roadoutbound/auto-load-efficiency",
    children: [
      {
        path: "/roadoutbound/auto-load-efficiency",
        name: "汽车装车作业时效分析",
        meta: { keepAlive: true },
        component: () => import("@/views/roadoutbound/auto-load-efficiency/index"),
      },
    ],
  },
  {
    path: "/basic-info/stockmanagem-3d",
    component: Layout,
    redirect: "/basic-info/stockmanagem-3d/index",
    children: [
      {
        path: "index",
        name: "煤棚库存3D展示",
        meta: { keepAlive: false },
        component: () =>
          import(/* webpackChunkName: "stock-3d" */ "@/views/basic-info/stockmanagem-3d/index"),
      },
    ],
  },
  {
    path: "/basic-info/yard-space-board",
    component: Layout,
    redirect: "/basic-info/yard-space-board/index",
    children: [
      {
        path: "index",
        name: "堆场空间管理看板",
        meta: { keepAlive: true },
        component: () =>
          import(
            /* webpackChunkName: "views" */ "@/views/basic-info/yard-space-board/index"
          ),
      },
    ],
  },
  {
    path: "/system/device-maintenance/statistics",
    component: Layout,
    redirect: "/system/device-maintenance/statistics/index",
    children: [
      {
        path: "index",
        name: "维保年度月度统计",
        meta: { keepAlive: true },
        component: () =>
          import(/* webpackChunkName: "views" */ "@/views/system/device-maintenance/statistics"),
      },
    ],
  },
  {
    path: "/system/device-maintenance/delay-audit",
    component: Layout,
    redirect: "/system/device-maintenance/delay-audit/index",
    children: [
      {
        path: "index",
        name: "维保延期审核",
        meta: { keepAlive: true },
        component: () =>
          import(/* webpackChunkName: "views" */ "@/views/system/device-maintenance/delay-audit"),
      },
    ],
  },
  {
    path: "/system/device-maintenance/complete-audit",
    component: Layout,
    redirect: "/system/device-maintenance/complete-audit/index",
    children: [
      {
        path: "index",
        name: "维保完成审核",
        meta: { keepAlive: true },
        component: () =>
          import(/* webpackChunkName: "views" */ "@/views/system/device-maintenance/complete-audit"),
      },
    ],
  },
  {
    path: "/kanban-management/monthly-trend-benchmark",
    component: Layout,
    redirect: "/kanban-management/monthly-trend-benchmark",
    children: [
      {
        path: "/kanban-management/monthly-trend-benchmark",
        name: "月度趋势标杆分析",
        meta: { keepAlive: true },
        component: () =>
          import(
            /* webpackChunkName: "views" */ "@/views/kanban-management/monthly-trend-benchmark/index"
          ),
      },
    ],
  },
  {
    path: "/kanban-management/daily-plan-tracking",
    component: Layout,
    redirect: "/kanban-management/daily-plan-tracking",
    children: [
      {
        path: "/kanban-management/daily-plan-tracking",
        name: "日计划完成情况跟踪",
        meta: { keepAlive: true },
        component: () =>
          import(
            /* webpackChunkName: "views" */ "@/views/kanban-management/daily-plan-tracking/index"
          ),
      },
    ],
  },
  {
    path: "/kanban-management/annual-indicators",
    component: Layout,
    redirect: "/kanban-management/annual-indicators",
    children: [
      {
        path: "/kanban-management/annual-indicators",
        name: "年度指标全景看板",
        meta: { keepAlive: true },
        component: () =>
          import(
            /* webpackChunkName: "views" */ "@/views/kanban-management/annual-indicators/index"
          ),
      },
    ],
  },
  {
    path: "/kanban-management/transport-plan-top10-customers",
    component: Layout,
    redirect: "/kanban-management/transport-plan-top10-customers",
    children: [
      {
        path: "/kanban-management/transport-plan-top10-customers",
        name: "TOP10客户运输排名",
        meta: { keepAlive: true },
        component: () =>
          import(
            /* webpackChunkName: "views" */ "@/views/kanban-management/transport-plan-top10-customers/index"
          ),
      },
    ],
  },
  {
    path: "/kanban-management/transport-plan-progress",
    component: Layout,
    redirect: "/kanban-management/transport-plan-progress",
    children: [
      {
        path: "/kanban-management/transport-plan-progress",
        name: "计划完成进度条",
        meta: { keepAlive: true },
        component: () =>
          import(
            /* webpackChunkName: "views" */ "@/views/kanban-management/transport-plan-progress/index"
          ),
      },
    ],
  },
  {
    path: "/kanban-management/shipment-overview",
    component: Layout,
    redirect: "/kanban-management/shipment-overview",
    children: [
      {
        path: "/kanban-management/shipment-overview",
        name: "汽运发运总览看板",
        meta: { keepAlive: true },
        component: () =>
          import(
            /* webpackChunkName: "views" */ "@/views/kanban-management/shipment-overview/index"
          ),
      },
    ],
  },
  {
    path: "/kanban-management/real-time-shipment-monitor",
    component: Layout,
    redirect: "/kanban-management/real-time-shipment-monitor",
    children: [
      {
        path: "/kanban-management/real-time-shipment-monitor",
        name: "实时发运监控看板",
        meta: { keepAlive: true },
        component: () =>
          import(
            /* webpackChunkName: "views" */ "@/views/kanban-management/real-time-shipment-monitor/index"
          ),
      },
    ],
  },
  {
    path: "/kanban-management/planned-vehicle-monitor",
    component: Layout,
    redirect: "/kanban-management/planned-vehicle-monitor",
    children: [
      {
        path: "/kanban-management/planned-vehicle-monitor",
        name: "计划来车监控看板",
        meta: { keepAlive: true },
        component: () =>
          import(
            /* webpackChunkName: "views" */ "@/views/kanban-management/planned-vehicle-monitor/index"
          ),
      },
    ],
  },
  {
    path: "/kanban-management/truck-efficiency-leaderboard",
    component: Layout,
    redirect: "/kanban-management/truck-efficiency-leaderboard",
    children: [
      {
        path: "/kanban-management/truck-efficiency-leaderboard",
        name: "汽运车辆运输效能榜",
        meta: { keepAlive: true },
        component: () =>
          import(
            /* webpackChunkName: "views" */ "@/views/kanban-management/truck-efficiency-leaderboard/index"
          ),
      },
    ],
  },
  {
    path: "/kanban-management/car-dumper-opc-monitor",
    component: Layout,
    redirect: "/kanban-management/car-dumper-opc-monitor",
    children: [
      {
        path: "/kanban-management/car-dumper-opc-monitor",
        name: "翻车机设备状态监测看板",
        meta: { keepAlive: true },
        component: () =>
          import(
            /* webpackChunkName: "views" */ "@/views/kanban-management/car-dumper-opc-monitor/index"
          ),
      },
    ],
  },
  {
    path: "/kanban-management/loading-bay-efficiency-rank",
    component: Layout,
    redirect: "/kanban-management/loading-bay-efficiency-rank",
    children: [
      {
        path: "/kanban-management/loading-bay-efficiency-rank",
        name: "装车台效率排名表",
        meta: { keepAlive: true },
        component: () =>
          import(
            /* webpackChunkName: "views" */ "@/views/kanban-management/loading-bay-efficiency-rank/index"
          ),
      },
    ],
  },
  {
    path: "/kanban-management/inspection-task-monitor",
    component: Layout,
    redirect: "/kanban-management/inspection-task-monitor",
    children: [
      {
        path: "/kanban-management/inspection-task-monitor",
        name: "巡检任务监控异常处理看板",
        meta: { keepAlive: true },
        component: () =>
          import(
            /* webpackChunkName: "views" */ "@/views/kanban-management/inspection-task-monitor/index"
          ),
      },
    ],
  },
  {
    path: "/kanban-management/device-asset-statistics",
    component: Layout,
    redirect: "/kanban-management/device-asset-statistics",
    children: [
      {
        path: "/kanban-management/device-asset-statistics",
        name: "设备资产统计分析",
        meta: { keepAlive: true },
        component: () =>
          import(
            /* webpackChunkName: "views" */ "@/views/kanban-management/device-asset-statistics/index"
          ),
      },
    ],
  },
  {
    path: "/kanban-management/device-energy",
    component: Layout,
    redirect: "/kanban-management/device-energy",
    children: [
      {
        path: "/kanban-management/device-energy",
        name: "设备能耗统计",
        meta: { keepAlive: true },
        component: () =>
          import(
            /* webpackChunkName: "views" */ "@/views/kanban-management/device-energy/index"
          ),
      },
    ],
  },
  {
    path: "/kanban-management/smoke-trend-analysis",
    component: Layout,
    redirect: "/kanban-management/smoke-trend-analysis",
    children: [
      {
        path: "/kanban-management/smoke-trend-analysis",
        name: "烟雾趋势分析",
        meta: { keepAlive: true },
        component: () =>
          import(
            /* webpackChunkName: "views" */ "@/views/kanban-management/smoke-trend-analysis/index"
          ),
      },
    ],
  },
  {
    path: "/kanban-management/dumper-realtime-overview",
    component: Layout,
    redirect: "/kanban-management/dumper-realtime-overview",
    children: [
      {
        path: "/kanban-management/dumper-realtime-overview",
        name: "翻车机实时作业总览看板",
        meta: { keepAlive: true },
        component: () =>
          import(
            /* webpackChunkName: "views" */ "@/views/kanban-management/dumper-realtime-overview/index"
          ),
      },
    ],
  },
  {
    path: "/kanban-management/device-alarm-chart-dynamic",
    component: Layout,
    redirect: "/kanban-management/device-alarm-chart-dynamic",
    children: [
      {
        path: "/kanban-management/device-alarm-chart-dynamic",
        name: "设备报警图表动态展示",
        meta: { keepAlive: true },
        component: () =>
          import(
            /* webpackChunkName: "views" */ "@/views/kanban-management/device-alarm-chart-dynamic/index"
          ),
      },
    ],
  },
  {
    path: "/kanban-management/device-alarm-count-stats",
    component: Layout,
    redirect: "/kanban-management/device-alarm-count-stats",
    children: [
      {
        path: "/kanban-management/device-alarm-count-stats",
        name: "设备报警数量统计与分类",
        meta: { keepAlive: true },
        component: () =>
          import(
            /* webpackChunkName: "views" */ "@/views/kanban-management/device-alarm-count-stats/index"
          ),
      },
    ],
  },
  {
    path: "/contingency-management/y-event-entry",
    component: Layout,
    redirect: "/contingency-management/y-event-entry/index",
    children: [
      {
        path: "/contingency-management/y-event-entry/index",
        name: "信息录入",
        meta: { keepAlive: true },
        component: () =>
          import(
            /* webpackChunkName: "views" */ "@/views/contingency-management/y-event-entry/index"
          ),
      },
    ],
  },
  {
    path: "/contingency-management/y-event-manage",
    component: Layout,
    redirect: "/contingency-management/y-event-manage/index",
    children: [
      {
        path: "/contingency-management/y-event-manage/index",
        name: "应急事件管理",
        meta: { keepAlive: true },
        component: () =>
          import(
            /* webpackChunkName: "views" */ "@/views/contingency-management/y-event-manage/index"
          ),
      },
    ],
  },
  {
    path: "/contingency-management/y-work-order",
    component: Layout,
    redirect: "/contingency-management/y-work-order/index",
    children: [
      {
        path: "/contingency-management/y-work-order/index",
        name: "工单管理",
        meta: { keepAlive: true },
        component: () =>
          import(
            /* webpackChunkName: "views" */ "@/views/contingency-management/y-work-order/index"
          ),
      },
    ],
  },
  {
    path: "/contingency-management/y-work-order-approval",
    component: Layout,
    redirect: "/contingency-management/y-work-order-approval/index",
    children: [
      {
        path: "/contingency-management/y-work-order-approval/index",
        name: "工单审批",
        meta: { keepAlive: true },
        component: () =>
          import(
            /* webpackChunkName: "views" */ "@/views/contingency-management/y-work-order-approval/index"
          ),
      },
    ],
  },
  {
    path: "/contingency-management/y-work-order-task",
    component: Layout,
    redirect: "/contingency-management/y-work-order-task/index",
    children: [
      {
        path: "/contingency-management/y-work-order-task/index",
        name: "工单任务管理",
        meta: { keepAlive: true },
        component: () =>
          import(
            /* webpackChunkName: "views" */ "@/views/contingency-management/y-work-order-task/index"
          ),
      },
    ],
  },
  {
    path: "/contingency-management/y-event-timeline",
    component: Layout,
    redirect: "/contingency-management/y-event-timeline",
    children: [
      {
        path: "/contingency-management/y-event-timeline",
        name: "应急事件时间轴",
        meta: { keepAlive: true },
        component: () =>
          import(
            /* webpackChunkName: "views" */ "@/views/contingency-management/y-event-timeline/index"
          ),
      },
    ],
  },
  {
    path: "/contingency-management/y-support-personnel",
    component: Layout,
    redirect: "/contingency-management/y-support-personnel",
    children: [
      {
        path: "/contingency-management/y-support-personnel",
        name: "应急保障人员信息",
        meta: { keepAlive: true },
        component: () =>
          import(
            /* webpackChunkName: "views" */ "@/views/contingency-management/y-support-personnel/index"
          ),
      },
    ],
  },
  {
    path: "/automobile-management/daily-plan-out-audit",
    component: Layout,
    redirect: "/automobile-management/daily-plan-out-audit/index",
    children: [
      {
        path: "/automobile-management/daily-plan-out-audit/index",
        name: "汽运出库日计划审核",
        meta: { keepAlive: true },
        component: () =>
          import(
            /* webpackChunkName: "views" */ "@/views/automobile-management/daily-plan-out-audit/index"
          ),
      },
    ],
  },
  {
    path: "/finance/own-vehicle",
    component: Layout,
    redirect: "/finance/own-vehicle/index",
    children: [
      {
        path: "/finance/own-vehicle/index",
        name: "自有车辆管理",
        meta: { keepAlive: true },
        component: () =>
          import(
            /* webpackChunkName: "views" */ "@/views/finance/own-vehicle/index"
          ),
      },
    ],
  },
  {
    path: "/finance/payment-order",
    component: Layout,
    redirect: "/finance/payment-order/index",
    children: [
      {
        path: "/finance/payment-order/index",
        name: "支付订单管理",
        meta: { keepAlive: true },
        component: () =>
          import(
            /* webpackChunkName: "views" */ "@/views/finance/payment-order/index"
          ),
      },
    ],
  },
  {
    path: "/finance/contract-pay-whitelist",
    component: Layout,
    redirect: "/finance/contract-pay-whitelist/index",
    children: [
      {
        path: "/finance/contract-pay-whitelist/index",
        name: "合同费用白名单",
        meta: { keepAlive: true },
        component: () =>
          import(
            /* webpackChunkName: "views" */ "@/views/finance/contract-pay-whitelist/index"
          ),
      },
    ],
  },
  {
    path: "/finance/contract-settlement-bill",
    component: Layout,
    redirect: "/finance/contract-settlement-bill",
    children: [
      {
        path: "/finance/contract-settlement-bill",
        name: "合同结算单",
        meta: { keepAlive: true },
        component: () =>
          import(
            /* webpackChunkName: "views" */ "@/views/finance/contract-settlement-bill/index"
          ),
      },
    ],
  },
  {
    path: "/meterenergy/record/electric-heat",
    component: Layout,
    redirect: "/meterenergy/record/electric-heat",
    children: [
      {
        path: "/meterenergy/record/electric-heat",
        name: "用电量数据智能采集",
        meta: { keepAlive: true },
        component: () =>
          import(
            /* webpackChunkName: "views" */ "@/views/meterenergy/record/electric-heat"
          ),
      },
    ],
  },
  {
    path: "/basic-info/team-schedule",
    component: Layout,
    redirect: "/basic-info/team-schedule/index",
    children: [
      {
        path: "/basic-info/team-schedule/index",
        name: "排班管理",
        meta: { keepAlive: true },
        component: () =>
          import(
            /* webpackChunkName: "views" */ "@/views/basic-info/team-schedule/index"
          ),
      },
    ],
  },
  // {
  //   path: "/basic-info/power-room-monitor",
  //   component: Layout,
  //   redirect: "/basic-info/power-room-monitor/index",
  //   children: [
  //     {
  //       path: "/basic-info/power-room-monitor/index",
  //       name: "配电室104综合监测配置",
  //       meta: { keepAlive: true },
  //       component: () =>
  //         import(
  //           /* webpackChunkName: "views" */ "@/views/basic-info/power-room-monitor/index"
  //         ),
  //     },
  //   ],
  // },
  {
    path: "/automobile-management/dynamic-inventory-management",
    component: Layout,
    redirect: "/automobile-management/dynamic-inventory-management/index",
    children: [
      {
        path: "/automobile-management/dynamic-inventory-management/index",
        name: "动态库存管理",
        meta: { keepAlive: true },
        component: () =>
          import(
            /* webpackChunkName: "views" */ "@/views/automobile-management/dynamic-inventory-management/index"
          ),
      },
    ],
  }
];
